function getToken() {
  let str = localStorage.getItem("token");
  if (!str) {
    return null;
  }
  return str;
}

const map = new Map([
  ["/", ""],
  ["/home", "用户"],
]);

function formatDate(timeStr) {
  // 处理传入的时间字符串，创建Date对象
  const date = new Date(timeStr);
  // 校验日期是否有效（避免传入非法字符串导致的Invalid Date）
  if (isNaN(date.getTime())) {
    console.error("传入的时间字符串格式无效:", timeStr);
    return ""; // 无效时返回空字符串，也可以根据需求返回默认值
  }

  // 获取传入日期的年、月、日
  const targetYear = date.getFullYear();
  const targetMonth = date.getMonth() + 1; // 月份是0-11，所以要+1
  const targetDay = date.getDate();

  // 获取当前年份
  const currentYear = new Date().getFullYear();

  // 补零函数：将单个数字转为两位数（如3→03）
  const padZero = (num) => num.toString().padStart(2, "0");

  // 拼接月份和日期（已补零）
  const monthDayStr = `${padZero(targetMonth)}月${padZero(targetDay)}日`;

  // 判断年份是否一致，返回对应格式
  return targetYear === currentYear
    ? monthDayStr
    : `${targetYear}年${monthDayStr}`;
}

export { getToken, map, formatDate };
